import Modal from '../../Layout/Modal'
import { useForm } from 'react-hook-form';

let processingId = -1;


const ModalSelectSubSubCategory = ({ mTable, useState, useRef, modalId, onCloseModal, getSubSubcategoryAll, useSelector, Overlay, uuid, MTable, onClickSubSubCat, onRowChecked, onAddSubSubCatModal }) => {
    let { userInfo } = useSelector(state => state.auth);

    const { register, handleSubmit, reset, control, setValue, formState: { errors } } = useForm({
        defaultValues: {
            id_category: '',
            sub_category_code: '',
            sub_category_name: '',
            init: '',
            is_active: true,
            sort: 0,
            selectedSubCat: ''
        }
    });

    const [state, setState] = useState({
        showForm: false,
        subcategory: {
            id_category: '',
            sub_category_code: '',
            sub_category_name: '',
            init: '',
            is_active: true,
            sort: 0,
            selectedSubCat: ''
        },
        segments: [],
        categories: [],
        processing: false,
        disabled: false,
        checked: []
    });

    const columns = [
        { id: uuid(), title: 'SubSubcategory Name', field: 'sub_sub_category_name', sortable: true, clickable: true },
        { id: uuid(), title: 'SubSubcategory Code', field: 'sub_sub_category_code', sortable: true, clickable: true },
        { id: uuid(), title: 'Sub Category Name', field: 'sub_category_name', sortable: true, clickable: true },
        { id: uuid(), title: 'Category Name', field: 'category_name', sortable: true, clickable: true },
        { id: uuid(), title: 'Initial', field: 'init', sortable: true, clickable: true },
        {
            id: uuid(),
            title: '',
            sortable: true,
            style: { width: 200 },
            render: item => {
                return (
                    <div>
                        {/* <EditButton title="Edit" onClick={onEdit(item)} />
                        <DeleteButton title="Remove" onClick={onRemove(item)} /> */}
                    </div>);
            },
        },
    ];

    const startProcessing = () => {
        processingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    }

    const stopProcessing = () => {
        clearTimeout(processingId);
        setState({ ...state, processing: false });
    }

    const { processing, checked } = state;


    const propsTable = { columns, getData: getSubSubcategoryAll, enableFilter: true, rowClick: onClickSubSubCat, setRowSelect: "sub_sub_category_name", onChecked: onRowChecked, showAddButton: false, };


    return (
        <Modal id={modalId} title="Select Sub Sub Category" onClose={onCloseModal} onAction='' btnActionName="" modalSize="modal-xl">
            <div className='col-md-12'>
                <div className='card'>
                    <Overlay display={processing} />
                    <form name="form-detail">
                        <div className='card-body'>
                            {/* <div className={`${!showForm ? 'card__side--front-show' : 'card__side--front'}`}> */}
                            <div className='card__side--front-show'>
                                <MTable ref={mTable} {...propsTable} showIndex={true} />
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </Modal >
    )
}

export default ModalSelectSubSubCategory